// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;99</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;The Lord is king: let the peoples tremble;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he is enthroned above the cherubim: let the earth shake.<br> </p> </div></div>";
// Exports
module.exports = code;